import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _get from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { WalletConnect } from '@web3-react/walletconnect-v2';
import { ALL_SUPPORTED_CHAIN_IDS, ALL_SUPPORTED_WC_RPC_URLS } from "../constants/chain";
export var WalletConnectV2 = /*#__PURE__*/function (_WalletConnect) {
  _inherits(WalletConnectV2, _WalletConnect);

  var _super = _createSuper(WalletConnectV2);

  function WalletConnectV2(_ref) {
    var actions = _ref.actions,
        defaultChainId = _ref.defaultChainId,
        onError = _ref.onError,
        _ref$qrcode = _ref.qrcode,
        qrcode = _ref$qrcode === void 0 ? true : _ref$qrcode;

    _classCallCheck(this, WalletConnectV2);

    return _super.call(this, {
      actions: actions,
      options: {
        projectId: process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
        chains: [defaultChainId],
        optionalChains: ALL_SUPPORTED_CHAIN_IDS,
        showQrModal: qrcode,
        rpcMap: ALL_SUPPORTED_WC_RPC_URLS,
        optionalMethods: ['eth_sendTransaction', 'eth_sendRawTransaction', 'eth_signTransaction', 'personal_sign', 'eth_signTypedData', 'eth_signTypedData_v4', 'eth_sign'],
        qrModalOptions: {
          themeMode: 'light',
          themeVariables: {
            '--w3m-z-index': '9999',
            '--wcm-z-index': '9999'
          }
        }
      },
      onError: onError
    });
  }

  _createClass(WalletConnectV2, [{
    key: "activate",
    value: function activate(chainId) {
      return _get(_getPrototypeOf(WalletConnectV2.prototype), "activate", this).call(this, chainId);
    }
  }]);

  return WalletConnectV2;
}(WalletConnect);